/** @format */

import React from 'react';

import './loading.scss';

export default ({height = '70vh', size = 150, message = 'Loading...,', className = ''}) => {
    return (
        <div className={`loading-container-main ${className}`} style={{height}}>
            <span id="loading1" style={{height: size, width: size}}>
                <span id="outerCircle" style={{height: size, width: size, borderRadius: size}}>
                    <span
                        id="innerCircle"
                        style={{
                            height: size * 0.75,
                            width: size * 0.75,
                            borderRadius: size * 0.75
                        }}>
                        <span
                            style={{
                                height: size * 0.5,
                                width: size * 0.5,
                                borderRadius: size * 0.5
                            }}
                            id="center">
                            <div
                                style={{
                                    height: size * 0.4,
                                    width: size * 0.4
                                }}>
                                <svg
                                    style={{width: '100%', height: 'auto'}}
                                    viewBox="0 0 400 360"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M98.4001 72.5C98.4001 83.7 97.9001 94.1 98.5001 104.4C99.7001 127.1 113.3 139.4 138.9 139.7C181.5 140.3 224.1 139.8 266.7 140.1C280.6 140.2 294.6 140.3 308.3 142C368.5 149.2 406.7 199.8 398.1 260.2C390 317.2 350.9 356.5 293.4 358.6C231.3 360.9 169.1 359.3 106.9 357.7C91.1001 357.3 74.9001 351.9 59.9001 346C13.2001 327.5 -2.99992 285.1 0.500079 240C30.7001 240 60.9001 240 91.7001 240C91.7001 243.2 91.7001 246.4 91.7001 249.5C91.7001 272.9 103.1 285.2 126.6 285.7C154.3 286.3 181.9 285.9 209.6 285.9C229.7 285.9 249.9 286 270 285.9C299.4 285.8 315.8 258.6 302.2 232.2C295.3 218.9 282.7 216.2 269.3 216.2C227.4 216.1 185.4 216.6 143.5 216C124 215.7 104.1 215.4 85.0001 211.6C40.5001 202.7 6.90008 158.7 6.90008 114.1C6.90008 82.1 6.90008 43 6.90008 0.0999984C22.8001 0.0999984 201.1 -0.200002 272 0.299998C287.7 0.399998 303.8 3.5 318.8 8.1C358.1 20.1 381.5 51 384.4 91.9C384.9 99.2 384.5 106.5 384.5 114.1C354.6 114.1 324.8 114.1 294.7 114.1C294.6 112.8 294.4 111.5 294.4 110.2C294.1 83.5 283.1 72.6 256.2 72.5C223 72.4 189.8 72.5 156.6 72.5C137.4 72.5 118.1 72.5 98.4001 72.5Z"
                                        fill="#000"
                                    />
                                </svg>
                            </div>
                        </span>
                    </span>
                </span>
            </span>
            <h4 className="loading-message-text" style={{fontSize: size * 0.12}}>
                {message}
            </h4>
        </div>
    );
};
